import {call, put} from "redux-saga/effects";
import {setLoading, setWishlist, setError} from "../../slices/wishlistSlice";
import {getWishlistService} from "../requests/wishlistService";

export function* handleGetWishlist(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => getWishlistService(action.payload))
    yield put(setWishlist(response.data))

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}